export default __webpack_public_path__ + "static/posterLeonardCohen-22180f0bcb50277866877c01a31a09a4.svg";